import { render, staticRenderFns } from "./SalaryCustomHeader.vue?vue&type=template&id=5db50b2e&scoped=true&"
import script from "./SalaryCustomHeader.vue?vue&type=script&lang=js&"
export * from "./SalaryCustomHeader.vue?vue&type=script&lang=js&"
import style0 from "./SalaryCustomHeader.vue?vue&type=style&index=0&id=5db50b2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db50b2e",
  null
  
)

export default component.exports